module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"btn_submit":"Продолжить","input_password":"Пароль","input_repeat_password":"Повтор пароля","error_password_required":"Укажите пароль","error_password_not_same":"Пароли не совпадают","error_password_min_length":"Длина пароля должна быть не менее {min} символов"}}')
  delete Component.options._Ctor
}
